import React from "react";
import { useForm } from "react-hook-form";
import { useUser } from "../../context/UserContext";
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import Button from '../UI/Button';

const EditTagModal = ({ tag, onClose, onUpdate }) => {
    const { logout } = useUser();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: tag.name || "",
            description: tag.description || "",
            type: tag.type || "entry",
            location: tag.location || "",
        },
    });

    const onSubmit = async (data) => {
        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/nfc-checkpoints/${tag._id}`,
                {
                    method: "PUT",
                    body: JSON.stringify(data),
                },
                logout
            );
            if (!res.ok) throw new Error("Ошибка при сохранении");
            onUpdate();
            onClose();
        } catch (err) {
            console.error("Ошибка сохранения:", err);
            alert("Ошибка при сохранении метки");
        }
    };

    return (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-[#252526] border border-[#3E3E42] text-[#CCCCCC] p-6 rounded-lg w-full max-w-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-6">Редактирование метки</h3>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                    <div>
                        <input
                            {...register("name", { required: true })}
                            className="w-full bg-[#1E1E1E] text-white p-2 rounded border border-[#555]"
                            placeholder="Название"
                        />
                        {errors.name && (
                            <p className="text-red-400 text-sm mt-1">Обязательно</p>
                        )}
                    </div>

                    <input
                        {...register("description")}
                        className="w-full bg-[#1E1E1E] text-white p-2 rounded border border-[#555]"
                        placeholder="Описание"
                    />

                    <select
                        {...register("type")}
                        className="w-full bg-[#1E1E1E] text-white p-2 rounded border border-[#555]"
                    >
                        <option value="entry">Вход</option>
                        <option value="exit">Выход</option>
                    </select>

                    <input
                        {...register("location")}
                        className="w-full bg-[#1E1E1E] text-white p-2 rounded border border-[#555]"
                        placeholder="Локация"
                    />

                    <div className="flex gap-4 justify-end pt-2">
                        <Button
                            type="button"
                            onClick={onClose}
                            variant="cancel"
                        >
                            Отмена
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                        >
                            Сохранить
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditTagModal;
